import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, Popover } from "antd";
import { userSignOut } from "../../appRedux/actions/Auth";
import profile from '../../assets/images/placeholder.jpg';

const UserProfile = () => {
  const dispatch = useDispatch();
  const { authUser } = useSelector(({ auth }) => auth);

  const userMenuOptions = (
    <ul className="gx-user-popover">
      <li onClick={() => dispatch(userSignOut())}>Logout</li>
    </ul>
  );

  return (

    <div className="gx-flex-row gx-align-items-center gx-mb-4 gx-avatar-row" style={{fontSize: "14px"}}>
      <Popover placement="bottomRight" content={userMenuOptions} trigger="hover">
        <Avatar src={profile} className="gx-size-30 gx-pointer gx-mr-3" alt="" />
        <span className="gx-avatar-name">
          {authUser.name.slice(0,15)} <i className="icon icon-chevron-down gx-fs-xxs gx-ml-1" />
        </span>
      </Popover>
    </div>

  )
};

export default UserProfile;
